export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/buble-loader/index.js??ref--3-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SearchArea.vue?vue&type=template&id=33a4ad89"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SearchArea.vue?vue&type=template&id=33a4ad89
// module id = 142
// module chunks = 0